export  const ADD_CLOTHE_TO_CART ="ADD_CLOTHE_TO_CART";
export  const ADD_CLOTHE_TO_FAVOURITE ="ADD_CLOTHE_TO_FAVOURITE";
export  const REMOVE_CLOTHE_FROM_CART ="REMOVE_CLOTHE_FROM_CART";
export  const REMOVE_CLOTHE_FROM_FAVOURITE ="REMOVE_CLOTHE_FROM_FAVOURITE";
